<template>
	<div class="ticket">
		<div class="row">
			<div class="col-md-6 col-lg-3">
				<va-small-box
					color="secondary"
					icon="ion-bag"
					:title="withOutReader"
					description="Sin leer"
					@more-click="clickToSmallBox"
					moreText="More info">
				</va-small-box>
			</div>
			<div class="col-md-6 col-lg-3 d-none d-md-block">
				<va-small-box
					color="green"
					icon="ion-stats-bars"
					title="53%"
					description="Sin actividad"
					moreText="More info">
				</va-small-box>
			</div>
			<div class="col-md-6 col-lg-3 d-none d-md-block">
				<va-small-box
					color="yellow"
					icon="ion-person-add"
					title="44"
					description="User Registrations"
					moreText="More info">
				</va-small-box>
			</div>
			<div class="col-md-6 col-lg-3 d-none d-md-block">
				<va-small-box
					color="red"
					icon="ion-pie-graph"
					title="65"
					description="Unique Visitors"
					moreText="More info">
				</va-small-box>
			</div>
		</div>

		<div>
			<nav class="navbar navbar-light bg-light">
				<div class="form-inline">
					<input class="form-control form-control-sm mr-sm-2" type="search" placeholder="Buscar" aria-label="Buscar" v-model="searchTickets" v-on:keyup.enter="getAllTickets(1)">
					<button class="btn btn-sm btn-outline-info my-2 my-sm-0" type="submit" @click="getAllTickets(1)">Buscar</button>
				</div>
			</nav>
			<table class="table table-sm table-striped table-hover">
				<thead>
					<tr>
						<th>id</th>
						<th class="d-none d-sm-block">Fecha Hora</th>
						<th>Asunto</th>
						<th>Usuario</th>
						<th>Destinatario</th>
						<th>Estado</th>
						<th>
							<form-ticket @saveTicketFromModal="saveTicketFromModal"></form-ticket>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in listTickets">
						<td>{{ item.id }}</td>
						<td  class="d-none d-sm-block">{{ item.created_at }}</td>
						<td>{{ item.subject }}</td>
						<td>{{ item.user }}</td>
						<td>{{ item.receiver }}</td>
						<td>
							<span class="badge badge-secondary">{{ item.status }}</span>
						</td>
						<td class="text-right">
							<i class="fas fa-trash-alt text-danger margin-right5" @click="removeListTickets(item)"></i>
							<router-link :to="'/ticket/' + item.id" class="far fa-arrow-alt-circle-right margin-right5"></router-link>
						</td>
					</tr>
				</tbody>
			</table>
			<pagination :pagination="paginationListTickets" @getAllList="getAllTickets"></pagination>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import ticket from '@/mixins/tickets'

import FormTicket from '@/components/FormTicket.vue'
import Pagination from '@/components/Pagination.vue'
import VASmallBox from '@/widgets/VASmallBox.vue'

export default {
	name: 'Tickets',
	mixins: [axiosAction, errors, mixin, ticket],
	data() {
		return {
			message : {
				text: '',
				success: false,
				data: []
			},
		}
	},
	computed: {
		withOutReader() {
			return this.listTickets.map((el) => el.status_id).indexOf(3)
		}
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Gestión de tickets')
			this.getAllTickets(1)
			this.setListeningTickets()
		},
		removeListTickets(item) {
			if(confirm('Esta a punto de borrar el tickets "' + item.id + ' (' + item.subject + ')".\n¿Quiere continuar? ')) {
				this.deleteTicket(item.id)
			}
		},
		saveTicketFromModal(objectTicket) {
			this.objectTicket = objectTicket
			this.saveTicket()
		},
		getAllTickets(page = 1) {
			this.$emit('showLockScreen', 'Obteniendo lista de Tickets . . .')
			this.axiosActionIS(this.apiBackend + this.methods.ticketShow + 'showticketsforuser?search=' + this.searchTickets + '&page=' + page, 'GET', 'resultgetAllTickets')
		},
   		clickToSmallBox () {
      		alert('click!!!: clickToSmallBox')
    	}
	},
	components: {
		'form-ticket': FormTicket,
		'pagination': Pagination,
		'va-small-box': VASmallBox,
	},
	mounted () {
		this.initModule()
	}
}
</script>